export function checkStickySupported() {
  const testNode = document.createElement('div');

  return ['', '-webkit-', '-moz-', '-ms-'].some(prefix => {
    try {
      testNode.style.position = prefix + 'sticky';
    } catch (e) {
      return;
    }

    return testNode.style.position !== '';
  });
}
